// extracted by mini-css-extract-plugin
export default {"catalogue-bg":"Catalogues_catalogue-bg__AED2Y","back-btn":"Catalogues_back-btn__1P3Yu","main-div":"Catalogues_main-div__k1ep1","btn-next":"Catalogues_btn-next__5TcLi"};